import { Combobox } from '@cinesend/ui-kit'
import { useState } from 'react'
import useUtilities from '../../hooks/use_utilities'
import { DISABLED_REASONS } from '../../constants/disabled_reasons'
import DisabledTooltip from '../disabled_tooltip'

const AssetTypes = ({ field, saveField }) => {
  const defaultAssetTypes = field.asset_types || []
  const [assetTypes, setAssetTypes] = useState(defaultAssetTypes)
  const [error, setError] = useState(null)
  const { assetTypes: availableAssetTypes } = useUtilities()
  const assetTypeOptions = availableAssetTypes?.map((opt) => ({ value: opt.value, label: opt.plural_label })) ?? []
  const isLocked = field?.uneditable_when_locked_attributes?.includes('use_languages') ?? false

  const update = (data) => {
    // Validate that at least one asset type is selected
    if (data.length === 0) {
      setError('At least one asset type must be selected.')
      // Don't update the state - retain the last selection
      return
    }

    // Clear error if validation passes
    setError(null)
    setAssetTypes(data)
    saveField({ asset_types: data })
  }

  return (
    <DisabledTooltip reason={isLocked ? DISABLED_REASONS.schemaLocked : null} className='block w-full'>
      <Combobox
        multiple
        options={assetTypeOptions}
        value={assetTypes}
        label={'Specified Asset Types'}
        description={'At least one asset type must be selected.'}
        error={error ?? undefined}
        onValueChange={(selected) => update(selected ?? [])}
        disabled={isLocked}
      />
    </DisabledTooltip>
  )
}

export default AssetTypes
